import { useEffect } from 'react';
import { message } from 'antd';
import { useDispatch } from 'react-redux';
import { Action } from 'redux-saga';
import { useCategory } from '../../../../store/category';
import { getMessageInError } from '../../../../hooks/fetch';
import {
  categoryById,
  categoryByIdClear,
  categoryByIdErrorClear,
  CategoryByIdParams,
} from '../../../../store/category/byId';

export const useCategoryById = () => {
  const dispatch = useDispatch();
  const { byId } = useCategory();

  const getCategoryById = (params: CategoryByIdParams) => {
    dispatch(categoryById(params) as Action);
  };

  useEffect(() => () => {
    dispatch(categoryByIdClear() as Action);
    dispatch(categoryByIdErrorClear() as Action);
  }, []);

  useEffect(() => {
    if (byId.error) {
      message
        .error(getMessageInError(byId.error))
        .then(() => dispatch(categoryByIdErrorClear() as Action));
    }
  }, [byId.error]);

  const clearCategoryById = () => {
    dispatch(categoryByIdClear() as Action);
    dispatch(categoryByIdErrorClear() as Action);
  };

  return {
    getCategoryById, clearCategoryById, response: byId.response, error: byId.error, loading: byId.loading,
  };
};

export default {
  useCategoryById,
};
